import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import LoginPage from './components/login/LoginPage';
import RequisitesPage from './components/requisites/RequisitesPage';
import ParticipantsPage from './components/participants/ParticipantsPage';
import ParticipantDetailsPage from './components/participants/ParticipantDetailsPage';
import NewParticipantPage from './components/participants/NewParticipantPage';
import NewExamPage from './components/exam/NewExamPage';
import AppSyncPage from './components/exam/AppSyncPage';
// Dummy pages
import AcuityTestPage from './components/exam/AcuityTestPage';
import BVMTRTestPage from './components/exam/BVMTRTestPage';
import SDMTTestPage from './components/exam/SDMTTestPage';
import CVLTIITestPage from './components/exam/CVLTIITestPage';
import ExamSubmitPage from './components/exam/ExamSubmitPage';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Route exact path="/" component={LoginPage} />
        <Route exact path="/requisites" component={RequisitesPage} />
        <Route exact path="/participants" component={ParticipantsPage} />
        <Route exact path="/participants/:id" component={ParticipantDetailsPage} />
        <Route exact path="/new_participant" component={NewParticipantPage} />
        <Route exact path="/new_exam/:id" component={NewExamPage} />
        <Route exact path="/app_sync" component={AppSyncPage} />

        <Route exact path="/acuity_test" component={AcuityTestPage} />
        <Route exact path="/bvmtr_test" component={BVMTRTestPage} />
        <Route exact path="/sdmt_test" component={SDMTTestPage} />
        <Route exact path="/cvltii_test" component={CVLTIITestPage} />
        <Route exact path="/exam_submit" component={ExamSubmitPage} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js